<template>
  <div>
    <!--  授权设置： -->
    <el-dialog :title="$t('message.authorizationSettings')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="400px" center>
      <div class="content">
        <div class="key">
          <el-checkbox v-model="detail.authorizedChek">装箱授权</el-checkbox>
        </div>
        <div class="key">
          <el-checkbox v-model="detail.is_pay_authorizedChek">入金授权</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      chat: "",
      authorized: this.$parent.detail.authorized ? true : false,
      is_pay_authorized: this.$parent.detail.is_pay_authorizedChek
        ? true
        : false,
    };
  },
  computed: {},
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        authorized: this.detail.authorizedChek ? 1 : 0,
        is_pay_authorized: this.detail.is_pay_authorizedChek ? 1 : 0,
      };
      this.$api.clienteleApi.setAuthorized(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .key {
    display: flex;

    text-align: center;
    margin-bottom: 20px;

    /deep/.el-radio {
      line-height: 40px;
    }
  }

  .val {
    flex: 3;
  }
}

/deep/.el-radio__input {
  transform: scale(1.5) !important;
}
</style>